import React from "react";

interface SubmenuTitleProps {
  children: string;
}

const SubmenuTitle: React.FC<SubmenuTitleProps> = ({ children }) => {
  return <h4 className="menu-submenu-title">{children}</h4>;
};

export default SubmenuTitle;
